import { Identifiable } from "./identifiable";
import { id } from "./id";
import { Holiday } from "./holiday";

type CalendarHolidays = {
  uuid: string;
  name: string;
  holidays: Identifiable<Holiday>[];
};

const calendarHolidays: CalendarHolidays = {
  uuid: id,
  name: "",
  holidays: [],
};

export type { CalendarHolidays };

export { calendarHolidays };
